import { GridColDef } from '@mui/x-data-grid-premium'

const description: GridColDef = {
	field: 'partClass',
	hideable: false,
	headerName: 'Description',
	flex: 1,
	sortable: false,
	valueGetter: ( _value, row ) => row.name ?? '',
}

export default description